import { useState } from 'react'

import classNames from 'classnames'
import { CoverDimensions } from 'globalTypes'

import Image from 'next/image'

import styles from './index.module.css'

export interface Props {
  /**
   * Additional classname
   */
  className?: string

  /**
   * Cover image URL
   */
  imageUrl: string

  /**
   * Cover dimensions are used to prefill space before effective loading by the browser
   */
  dimensions?: CoverDimensions | null

  /**
   * The Cover image will span full width and height, covering the container
   */
  full?: boolean
}

const OptimizedImage = ({ url, full }) => {
  const [loaded, setLoaded] = useState<boolean>(false)

  const handleOnLoadComplete = () => {
    setLoaded(true)
  }

  return (
    <Image
      src={url}
      alt={url}
      className={classNames(
        'bg-gray-100',
        !loaded && 'animate-pulse',
        'min-w-full',
        full && 'w-full h-full object-cover'
      )}
      loading="lazy"
      width={384}
      height={216}
      sizes="(max-width: 375px) 300px, (max-width: 768px) 768px, 1280px"
      onLoadingComplete={handleOnLoadComplete}
    />
  )
}

const CoverImage: React.FC<Props> = ({ className, imageUrl, full }: Props) => {
  if (!imageUrl) return null

  return (
    <div
      className={classNames(styles.wrapper, className, full && 'w-full h-full')}
    >
      <OptimizedImage url={imageUrl} full={full} />
    </div>
  )
}

export default CoverImage
